export default __webpack_public_path__ + "25dce51450df464e972d632fa2992cc8.svg";